import { render } from "./TopicComment.vue?vue&type=template&id=1a6e816c&scoped=true"
import script from "./TopicComment.vue?vue&type=script&lang=js"
export * from "./TopicComment.vue?vue&type=script&lang=js"

import "./TopicComment.vue?vue&type=style&index=0&id=1a6e816c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6e816c"]])

export default __exports__